module.exports = __webpack_public_path__ + "img/hero_banner.17ee9930.png";